/* global L:false, topojson:false, H:false*/
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .constant('Hmaps', H);
})();
